import { translate } from "app/filters/i18nFilter";
import type { CrmField } from "app/pages/sales-intelligence/domain/leads/types/filter-options";
import type { IDropdownItem } from "app/pages/sales-intelligence/modules/leads-search-filters/types/options.dto";

export const createDropdownItems = (field: CrmField): IDropdownItem[] =>
    field.fieldValuesMap?.map(({ key, value }) => ({
        id: key,
        text: value || translate("si.lead_gen_filters.category.exclude.crm.dropdown.blank"),
    })) ?? [];

export const getSelectAllLabel = (): string => translate("si.lead_gen_filters.category.exclude.crm.dropdown.all_items");
